import { z } from 'zod';

/**
 * Marketer-controlled discount tier carried on the email-verification link (`?offer=`).
 * Mapped to a real promocode server-side (saturn, allowlisted) at click time — the link never
 * carries the code itself. `none` = no discount. Unknown/absent values fail closed to `none`.
 *
 * To add a magnitude (e.g. `discount15`): add it here AND map it per-product in saturn's allowlist
 * (`getEmailVerificationPromocodeForOfferTier`). The exhaustive `Record<OfferTier, ...>` there forces a
 * mapping for every tier, so a new tier can never silently resolve to "no discount" by omission.
 *
 * NOTE: lives in contracts-galatea for now because only the Galatea verify flow consumes it. When CandyJar
 * adopts the same offer model, promote this to contracts-common so the gtv contract can share it.
 */
export const offerTiers = ['discount30', 'none'] as const;

export const offerTierSchema = z.enum(offerTiers);

export type OfferTier = z.infer<typeof offerTierSchema>;

export const isOfferTier = (value: unknown): value is OfferTier =>
  typeof value === 'string' && (offerTiers as readonly string[]).includes(value);
